import type { NextPage } from "next";
import Head from "next/head";

import Landing from "@components/Landing";

const Header = () => (
  <Head>
    <title>
      Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kernel Points!
    </title>
    <meta
      name="description"
      content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kernel Points."
    />
    <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="96x96" />
    <meta name="robots" content="index, follow" />
  </Head>
);

const Home: NextPage = () => {
  return (
    <>
      <Header />
      <Landing />
    </>
  );
};

export default Home;
